import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core"
// import AppBar from '@mui/material/AppBar';
// import Box from '@mui/material/Box';
// import Toolbar from '@mui/material/Toolbar';
// import Typography from '@mui/material/Typography';
// import Button from '@mui/material/Button';
// import IconButton from '@mui/material/IconButton';
// import MenuIcon from '@mui/icons-material/Menu';
import "../styles/Nav.css";
import logo from '../logo.png';
import { useHistory, withRouter } from 'react-router-dom'

function Nav() {

  const history = useHistory();
  const [Hide, setHide] = useState(false)
  const [nav, setNav] = useState(false)
  const [navhide, setnavhide] = useState(false)
  useEffect(() => {
    // console.log("LOC",history.location);
    const p = history.location.pathname;

    if (p === '/membership/signup' || p.includes('admin') || p.includes("/member/")) {
      setHide(true)
    }
    else {
      setHide(false)
    }
    if (p === '/membership_login' || p === '/MemberForgetPass' || p === '/MembernewPass' || p === '/MembersendOtp') {
      setnavhide(true)
    }
    else {
      setnavhide(false)
    }

  }, [history.location])

  const sideNave = () => {
    history.replace('/resMemsidenav')
    setNav(true)

  }
  const backNave = () => {
    history.replace('/member/deshboard')
    setNav(false)
  }

  return (
    <>
      <nav className="nav">
        <div className="respons"></div>
        {/* {  navhide ?
            <div className="respons">
             
            </div> : <div className="respons">
              {
                nav ? <Button variant="contained" color="primary" onClick={backNave} style={{ position: 'relative', top: '15px', left: '10px' }}>Back</Button> :
                  <Button variant="contained" color="primary" onClick={sideNave} style={{ position: 'relative', top: '15px', left: '10px' }}>Menu</Button>
              }

            </div>
        } */}
        <div className="navCon">
          <div style={{ display: 'flex', color: 'white', alignItems: 'center', gap: '10px' }}>
            <a href="/">
              <img src={logo} width={50} height={50} alt="logo" />
            </a>
            <h3>NMO Bharat</h3>
          </div>
          {
            !Hide &&
            <ul>

              <li>
                <Link className="link" to={"/"}><Button variant="contained" color="primary">Home</Button> </Link>
              </li>
              <li>
                <Link className="link" to={"/membership"}><Button variant="contained" color="primary">Become a Member</Button></Link>
              </li>
              <li>
                <Link className="link" to={"/login"}><Button variant="contained" color="primary">Admin</Button></Link>
              </li>
              <li>
                <Link className="link" to={"/membership_login"}><Button variant="contained" color="primary">Member Login</Button></Link>
              </li>
            </ul>

          }
          <p className="moto">स्वास्थ्य सेवा, राष्ट्र सेवा</p>
        </div>
        <div className="navCon1">
          <a href="/">
            <div className = "nmologo" >
            <img src={logo} width={50} height={50} alt="logo" />
            </div>
          </a>
          <p className="moto">स्वास्थ्य सेवा, राष्ट्र सेवा</p>
        </div>
      </nav>
    </>
  );
}

export default withRouter(Nav);
